import React, { useEffect, useState } from "react";
import classes from "./artistProfile.module.css";
import ProfileSideMenu from "../ProfileSideMenu";
import Payments from "./Payments";
import TestimonialSection from "./TestimonialsSection";
import BookingSection from "./BookingSection";
import Calendar from "./Calendar";
import Preferences from "./Preferences";
import Settings from "./Settings";
import Home from "./Home";
import CreatePackages from "./CreatePackages";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../../redux/slices/artistProfileSlice";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Footer from "../../../components/footer";
import JobProposals from "./Jobs";
import ApproveComponent from "../../../components/ApproveComponent";

const ArtistProfileDashboard = () => {
  const [activeSection, setActiveSection] = useState("home");
  const dispatch = useDispatch();
  const router = useNavigate();
  const user = Cookies.get("user");
  const userParsed = JSON.parse(user);
  const { artistProfile } = useSelector((state) => state.artistProfile);
  const isAdmin = artistProfile?.email === "support@artistnextdoor.in";

  useEffect(() => {
    if (userParsed?.type != "artist") {
      router("/dashboard/user");
    }
    dispatch(getProfile());
  }, []);

  return (
    <>
      <div className={classes.outerMostContainer}>
        <ProfileSideMenu
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          isUserAnArtist={true}
          artistProfile={artistProfile}
        />

        {activeSection == "payments" && <Payments />}
        {activeSection == "testimonials" && <TestimonialSection />}
        {activeSection == "bookings" && <BookingSection />}
        {activeSection == "preferences" && (
          <Preferences userData={artistProfile} />
        )}
        {activeSection == "settings" && <Settings />}
        {activeSection == "home" && (
          <Home
            setActiveSection={setActiveSection}
            artistProfile={artistProfile}
          />
        )}
        {activeSection == "createPackages" && <CreatePackages />}
        {activeSection == "jobs" && <JobProposals />}
        {activeSection == "admin" && isAdmin && <ApproveComponent />}

        {/* // /> // {activeSection == "home" && <HomeSection />}
      // {activeSection == "profile" && <ProfileSection />}
      // {activeSection == "bookings" && <BookingSection />} */}
      </div>
      <Footer />
    </>
  );
};

export default ArtistProfileDashboard;
